import {Grid} from '@jobseeker/lotus/foundations';
import HeaderNoAuth from '@jobseeker/feature-navigation/components/Header/HeaderNoAuth';

import type {HeaderHarnessProps} from '@jobseeker/feature-navigation/components/Header/types';

import {ImageholderVariants} from '@jobseeker/lotus/components/ImageHolder/enums';
import {useIsCustomWidth} from '@jobseeker/lotus/hooks';
import {shallowEqual, useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import {isCSR} from '@jobseeker/lotus/utils';

const isMobile = (belowLg: boolean, device: string) => {
  if (isCSR()) {
    return belowLg;
  } else {
    return device === 'mobile' ? true : false;
  }
};

const HeaderWithNoAuth = (props: HeaderHarnessProps) => {
  const isTabAndMobile = useIsCustomWidth('lg');
  const {device} = useSelector(
    (state: AppState) => state.app.layout,
    shallowEqual
  );
  console.log('🚀 ~ isMobile ~ device:', isMobile(isTabAndMobile, device));
  return (
    <Grid container spacing={0} justifyContent="space-between">
      <HeaderNoAuth
        {...props}
        appBarProps={{
          position: 'fixed',
          color: 'inherit',
          sx: {
            borderBottomLeftRadius: 16,
            borderBottomRightRadius: 16,
            zIndex: 990,
          },
        }}
        container={{
          maxWidth: false,
          sx: {
            maxWidth: '1440px',
            px: {xxs: 2, md: 2, xxl: 0},
          },
        }}
        imageProps={{
          variant: ImageholderVariants.WITHLINK,
          imageSpec: {
            src: props.meta.logo,
            alt: process.env.NEXT_PUBLIC_APP_NAME,
            width: 85,
            height: 34,
            loading: 'eager',
          },
          imgStyle: {
            maxWidth: '95px',
          },
          linkProps: {
            href: '/',
          },
        }}
        isMobileDevice={isMobile(isTabAndMobile, device)}
        showMenu={false}
        showMenuSelect={false}
        data-testid="header-non-auth"
      />
    </Grid>
  );
};

export default HeaderWithNoAuth;
